const HUB_API_PREFIXES = [
  '/servers',
  '/auth',
  '/push',
  '/users',
  '/roles',
  '/identity',
  '/platform',
  '/android-devices',
  '/deploy-hooks',
  '/git-connections',
  '/cloudflare',
  '/dns-providers',
  '/storage',
  '/app-publishing',
  '/acme',
  '/security-center',
  '/security/waf',
  '/container-security',
  '/audit',
  '/workspaces',
  '/observability',
  '/vscode',
  '/ai-cli',
  '/ai-api',
  '/ai-management',
  '/load-balancers',
  '/database-instances',
  '/global-ssh-keys',
  '/backup-center',
  '/api-test',
  '/fleet-rollouts',
  '/billing',
  '/migrations',
  '/ip-intelligence',
] as const

/** Merkez veritabanı/kasa uçlarını seçili sunucunun agent'ına göndermeyi engeller. */
export function isHubApiPath(path: string): boolean {
  const normalized = path.startsWith('/api/') ? path.slice(4) : path
  return HUB_API_PREFIXES.some(prefix =>
    normalized === prefix || normalized.startsWith(`${prefix}/`) || normalized.startsWith(`${prefix}?`),
  )
}
